import { isLiveDate } from "./isLiveDate";

const getIsBenefitEventActive = (config = {}, loyaltyBenefitType) => {
  const benefit = config?.benefits?.find(
    benefit => benefit.type === loyaltyBenefitType
  );

  return !!benefit?.eventSchedule?.events?.some(event => isLiveDate(event));
};

export default getIsBenefitEventActive;
